import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { filterActions } from "../../../../store/filter";
import { useDispatch, useSelector } from "react-redux";
import SpecificFilter from "../../megaFilters/specificFilters/SpecificFilter";
import { setFiltersInLocalStorage } from "../../../../lib/filters";
import { workqueueActions } from "../../../../store/workqueue";
import { retrieveSpecificWorkQ } from "../../../../lib/systemData";

export default function QuickFilters({quickFilters, workQ, filtersValues, generalAsyncSearchFilter}) {
    const dispatch = useDispatch()
    const { workqSlug } = useParams()
    const settingsRevision = useSelector((state) => state.system.settingsRevision)

    const resolvedWorkQ = useMemo(() => {
        return retrieveSpecificWorkQ(workqSlug) ?? workQ
    }, [workqSlug, settingsRevision, workQ])

    const resolvedQuickFilters = quickFilters ?? resolvedWorkQ?.quick_filters

    const array = useMemo(() => {
        const items = []
        if (resolvedQuickFilters && resolvedWorkQ?.filter_groups) {
            resolvedQuickFilters.forEach(item => {
                resolvedWorkQ.filter_groups.forEach(group => {
                    if (group.key == item) {
                        items.push(group)
                    }
                })
            })
        }
        return items
    }, [resolvedQuickFilters, resolvedWorkQ])

    function mainSelectAction(value) {
        let updateobject = {
            ...filtersValues
        }     
        
        let update = JSON.parse(JSON.stringify(updateobject))

        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array
            
            update[value.identifier.type] = value.data.value

        } else {
            update[value.identifier.type] = value.data.value

            if (value.identifier.type == 'do_not_lien') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            if (value.identifier.type == 'ihc_review') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            
        }

        if (value.identifier.type == 'payer_type') { // if it is payer_type reset the payer status!!!!
            update.payer_status = null
        }

        dispatch(filterActions.setFiltersMultiple(update))
        dispatch(filterActions.setCurrentPage(1)) //set the page to 1 to avoid pagination issues
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1
        
        //add the filters in local storage for persistent filtering after refresh
        setFiltersInLocalStorage(update, resolvedWorkQ?.slug)
    }


    return <>
        {array.map(filter => (
            <SpecificFilter key={filter.key} item={filter} mainSelectAction={mainSelectAction} generalAsyncSearchFilter={generalAsyncSearchFilter} filtersValues={filtersValues} workQ={resolvedWorkQ} isQuickFilter={true} />
        ))}
    </>
}
